const QUERIES = {
  LIST: 'list',
}

const MODULE = {
  ROLE: 'Role'
}
export {QUERIES}
